import angular from 'angular'

import template from './vd-in-page-help.html'

/**
 * Directive for the in page help section
 */
angular.module('vend.ui').directive('vdInPageHelp', function () {
  return {
    scope: {
      media: '=',
      dismissible: '=',
      constrained: '=',
    },
    transclude: true,
    template,
    bindToController: true,
    controllerAs: 'vdInPageHelpCtrl',
    link($element, $attrs) {
      $attrs.addClass('vd-in-page-help')
    },
    controller() {},
  }
})
